import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import HomepageTemplate from 'gatsby-theme-carbon/src/templates/Homepage';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = HomepageTemplate;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Getting Started`}</h2>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Early Sales Demo Assets" title="Are you starting your Sales Cycle? What about Videos and QwikDemos to introduce CP4MCM?" href="/esd/overview" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/9oADAMBAAIQAxAAAAHWkmJFCw//xAAYEAADAQEAAAAAAAAAAAAAAAAAAQIRA//aAAgBAQABBQKqRagrjLe6UtH0cn//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAdEAACAgEFAAAAAAAAAAAAAAAAEQECEiEiMTJR/9oACAEBAAY/Ai23Wvo8UdpHMi5P/8QAGhAAAwEBAQEAAAAAAAAAAAAAAREhAEExUf/aAAgBAQABPyEtD7BgSFIaS6TGAnzAQ9vIsbhdOKTHWt//2gAMAwEAAgADAAAAENwv/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIWH/2gAIAQMBAT8QbywnT//EABcRAQEBAQAAAAAAAAAAAAAAAAERACH/2gAIAQIBAT8QDsuab//EAB4QAQEAAgICAwAAAAAAAAAAAAERACExYVFxgaHx/9oACAEBAAE/EAkQJtdrdfWQkgQi9gwlRQm7TjnJEsU9B5+cLbRtNvT+YjSbk7M//9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "early sales",
              "title": "early sales",
              "src": "/learninghub/static/54ad68cbb8020f7fcdef1a93cbff64c1/2e753/early-sales.jpg",
              "srcSet": ["/learninghub/static/54ad68cbb8020f7fcdef1a93cbff64c1/69549/early-sales.jpg 288w", "/learninghub/static/54ad68cbb8020f7fcdef1a93cbff64c1/473e3/early-sales.jpg 576w", "/learninghub/static/54ad68cbb8020f7fcdef1a93cbff64c1/2e753/early-sales.jpg 1152w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="white" subTitle="Requesting Your Demo Environment" title="Do you want to know how to request your CP4MCM on ROKS?" href="/environment/overview" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAEDBf/EABQBAQAAAAAAAAAAAAAAAAAAAAL/2gAMAwEAAhADEAAAAcWsGxMYV//EABkQAAMBAQEAAAAAAAAAAAAAAAABAhEDMf/aAAgBAQABBQKEdJxCrB3TH7//xAAWEQADAAAAAAAAAAAAAAAAAAAQESH/2gAIAQMBAT8BVH//xAAWEQEBAQAAAAAAAAAAAAAAAAARARD/2gAIAQIBAT8BSZ//xAAYEAADAQEAAAAAAAAAAAAAAAAAECEBAv/aAAgBAQAGPwIqhetX/8QAGBABAQEBAQAAAAAAAAAAAAAAAQAhMRH/2gAIAQEAAT8hB7cAmZknjMRwjdeD3Zz/2gAMAwEAAgADAAAAEGvv/8QAFhEBAQEAAAAAAAAAAAAAAAAAAREA/9oACAEDAQE/EFtXFm//xAAWEQEBAQAAAAAAAAAAAAAAAAABABH/2gAIAQIBAT8QDhkhf//EABoQAQEBAQADAAAAAAAAAAAAAAERAEExUWH/2gAIAQEAAT8Qv2/APOn9Q3jWDMk1ByslkLietRb/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "multi cloud",
              "title": "multi cloud",
              "src": "/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/2e753/multi-cloud.jpg",
              "srcSet": ["/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/69549/multi-cloud.jpg 288w", "/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/473e3/multi-cloud.jpg 576w", "/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/2e753/multi-cloud.jpg 1152w", "/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/74f4b/multi-cloud.jpg 1728w", "/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/de5bb/multi-cloud.jpg 2304w", "/learninghub/static/d2c987e9c8bff0ea05aa9e264b97e4ad/9dba4/multi-cloud.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Preparing Your Environment for a Demo" title="Do you want to know how to prepare and configure your environment for a Demo?" href="/readings" actionIcon="arrowRight" author="Coming Soon" disabled mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAEDBf/EABcBAAMBAAAAAAAAAAAAAAAAAAABAwT/2gAMAwEAAhADEAAAAVbPtqiyQz//xAAZEAADAQEBAAAAAAAAAAAAAAAAAQIREhP/2gAIAQEAAQUChLWVPTlodaep/8QAFBEBAAAAAAAAAAAAAAAAAAAAEP/aAAgBAwEBPwE//8QAFREBAQAAAAAAAAAAAAAAAAAAEBH/2gAIAQIBAT8Bh//EABoQAAMAAwEAAAAAAAAAAAAAAAABERIhUUH/2gAIAQEABj8C430shuU0pNoxPUf/xAAaEAADAQEBAQAAAAAAAAAAAAABESEAMUHx/9oACAEBAAE/IUXoUYelAKnowIEQvVcJg6FkbAZRQ3xHf//aAAwDAQACAAMAAAAQ39//xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAgBAwEBPxBX/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERQf/aAAgBAgEBPxB6Iz//xAAeEAEBAAICAgMAAAAAAAAAAAABEQAhMWFBUZGh8P/aAAgBAQABPxCR3IQb5Xv9vAOedFNHBPGut85SLE1FEO5irJOkvYvPxkrWl7QthVApwTAq0T0afZn/2Q==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "prereqs",
              "title": "prereqs",
              "src": "/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/2e753/prereqs.jpg",
              "srcSet": ["/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/69549/prereqs.jpg 288w", "/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/473e3/prereqs.jpg 576w", "/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/2e753/prereqs.jpg 1152w", "/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/74f4b/prereqs.jpg 1728w", "/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/de5bb/prereqs.jpg 2304w", "/learninghub/static/85a2a1dc4c4160455f5a2086a37a04af/9dba4/prereqs.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <Row mdxType="Row">
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="white" subTitle="Learning with Hands-on Labs" title="Do you want to learn more about CP4MCM using your ROKS environment?" href="/labs/overview" actionIcon="arrowRight" author="Coming Soon" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAIDBAX/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEAMQAAAByZlcrikf/8QAGhAAAwEAAwAAAAAAAAAAAAAAAAECAxESIv/aAAgBAQABBQJN5irib9Vm+xUMbP/EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8BP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8BP//EABsQAAMAAgMAAAAAAAAAAAAAAAABERASIUFR/9oACAEBAAY/AnOxxQrNSLn3H//EABoQAQADAQEBAAAAAAAAAAAAAAEAESExUWH/2gAIAQEAAT8hqmOV+S4gHGr2JutSUfTyALrC6i3P/9oADAMBAAIAAwAAABDHP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQMBAT8QP//EABQRAQAAAAAAAAAAAAAAAAAAABD/2gAIAQIBAT8QP//EABwQAQACAgMBAAAAAAAAAAAAAAEAESExQWGRgf/aAAgBAQABPxANLRV9H2UyRnijmnOrJryl3bxGJNYEmoNoyGinPkC811Wp/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "activities",
              "title": "activities",
              "src": "/learninghub/static/1410eb967b065107d7bf4d231bf356d0/2e753/activities.jpg",
              "srcSet": ["/learninghub/static/1410eb967b065107d7bf4d231bf356d0/69549/activities.jpg 288w", "/learninghub/static/1410eb967b065107d7bf4d231bf356d0/473e3/activities.jpg 576w", "/learninghub/static/1410eb967b065107d7bf4d231bf356d0/2e753/activities.jpg 1152w", "/learninghub/static/1410eb967b065107d7bf4d231bf356d0/74f4b/activities.jpg 1728w", "/learninghub/static/1410eb967b065107d7bf4d231bf356d0/de5bb/activities.jpg 2304w", "/learninghub/static/1410eb967b065107d7bf4d231bf356d0/9dba4/activities.jpg 2800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Delivering a Workshop" title="Are you planning to deliver a Workshop using your ROKS environment?" href="/workshop/overview" actionIcon="arrowRight" author="Coming Soon" disabled mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMEAgX/xAAVAQEBAAAAAAAAAAAAAAAAAAABAP/aAAwDAQACEAMQAAAB7CdxDeLI/8QAGhAAAgIDAAAAAAAAAAAAAAAAAQIAAxMhIv/aAAgBAQABBQIRrOlOQGKJVpP/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAEDAQE/AT//xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAcEAACAQUBAAAAAAAAAAAAAAAAEQECEBIhQTL/2gAIAQEABj8CIXnpluLVQ+iSP//EABsQAAICAwEAAAAAAAAAAAAAAAERACExQVFh/9oACAEBAAE/IfRC5Cg2k4XFIIPZhHXiorlTpuf/2gAMAwEAAgADAAAAEDP/AP/EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAwEBPxANZ//EABYRAQEBAAAAAAAAAAAAAAAAAAEQEf/aAAgBAgEBPxBcn//EAB0QAQEAAwACAwAAAAAAAAAAAAERACExQYFRYcH/2gAIAQEAAT8QNCAN+2LuJbopunnmAY1gaqfOJ4nvGVDuGWS994Gtk/ouf//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "workshop",
              "title": "workshop",
              "src": "/learninghub/static/ecb6b05eb00068cb7973cbc28bee2d41/2e753/workshop.jpg",
              "srcSet": ["/learninghub/static/ecb6b05eb00068cb7973cbc28bee2d41/69549/workshop.jpg 288w", "/learninghub/static/ecb6b05eb00068cb7973cbc28bee2d41/473e3/workshop.jpg 576w", "/learninghub/static/ecb6b05eb00068cb7973cbc28bee2d41/2e753/workshop.jpg 1152w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="white" subTitle="Resources" title="Are you looking for other resources and assets?" href="/resources" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "75%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAPABQDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAIDAQT/xAAWAQEBAQAAAAAAAAAAAAAAAAACAQP/2gAMAwEAAhADEAAAAcldRoxzin//xAAaEAABBQEAAAAAAAAAAAAAAAAAAQIDEiEz/9oACAEBAAEFAosbXIeaWFRxp//EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAgBAwEBPwEMLL//xAAWEQEBAQAAAAAAAAAAAAAAAAABEEH/2gAIAQIBAT8B1Z//xAAYEAEBAAMAAAAAAAAAAAAAAAAAQQERMf/aAAgBAQAGPwLLTiIj/8QAHRAAAgIBBQAAAAAAAAAAAAAAAAERIRAxQVFxgf/aAAgBAQABPyHYbJNWWk+2I0nMkSrAO4//2gAMAwEAAgADAAAAECzP/8QAFxEAAwEAAAAAAAAAAAAAAAAAAAERMf/aAAgBAwEBPxCQrgx//8QAGBEAAgMAAAAAAAAAAAAAAAAAAAERIVH/2gAIAQIBAT8Qd7CT/8QAHBAAAwEAAgMAAAAAAAAAAAAAAREhADFRYXHh/9oACAEBAAE/EEBaCRAk/msTDloWXjPSiJJ7wqB9064z0nipSPT3/9k=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "resources",
              "title": "resources",
              "src": "/learninghub/static/08a3e7bdcbd4c4771ff4207588cc1709/2e753/resources.jpg",
              "srcSet": ["/learninghub/static/08a3e7bdcbd4c4771ff4207588cc1709/69549/resources.jpg 288w", "/learninghub/static/08a3e7bdcbd4c4771ff4207588cc1709/473e3/resources.jpg 576w", "/learninghub/static/08a3e7bdcbd4c4771ff4207588cc1709/2e753/resources.jpg 1152w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      